import { Injectable, EventEmitter } from '@angular/core';
import { HederaManagerService, IWorld, CanvasStatus } from 'ngx-hedera';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export enum ScenaIveco {
  RECEPTION = 'reception',
  OFFICE_TCO = 'office-tco',
  SALES_MANAGER = 'sales-manager',
  OFFICE_2 = 'office-2',
  OFFICE_3 = 'office-3',
  DOORWAY = 'doorway'
}

@Injectable({providedIn: 'root'})
export class CanvasService {

  constructor(private hederaManager: HederaManagerService) {
    this.hederaStartup.subscribe(world => {
      this.world = world;
      this.hederaReady = true;
    });
  }

  /**
   * True se hedera é giá stato inizializzato
   */
  hederaReady = false;

  /**
   * world di hedera
   */
  world: IWorld;

  /**
   * Emesso al primo caricamento di hedera
   */
  hederaStartup = new EventEmitter<IWorld>();

  /**
   * Emesso ad ogni cambio di scena
   */
  sceneChange = new EventEmitter<string>();

  /**
   * Emesso ad ogni update di hedera
   */
  sceneUpdate = new EventEmitter<CanvasStatus>();

  /**
   *
   * @param openScene ?
   *
   * Mostra il canvas in sottofondo ( Passare 'openScene' con l'id della scena per caricare una scena )
   *
   */
  show(openScene?: ScenaIveco): Observable<IWorld> {
    const el = document.getElementById('canvas');
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    el.style.display = 'block';

    return (this.hederaReady ? of(this.world) : this.hederaStartup).pipe(tap(() => {
      if (openScene && (!this.hederaManager.activeScene || this.hederaManager.activeScene.id !== openScene)) {
        if (this.hederaManager.activateScene(openScene)) {
          console.log('Canvas - Start MainLoop!');
          this.sceneChange.emit(openScene);
        }
      }
    }));
  }


  /**
   *
   * @param stop
   *
   * Nasconde il canvas ( Passare 'stop' true per togliere tutti gli elementi dalla coda di rendering di hedera  )
   *
   */
  hide(stop: boolean = true) {
    const el = document.getElementById('canvas');
    document.body.style.overflow = 'auto';
    el.style.display = 'none';
    if (stop) {
      console.log('Canvas - Pausa MainLoop!');
      this.hederaManager.deactivateScene();
      if (this.world) {
        this.world.mainLoopPause();
      }
    }
  }

  /**
   * Sfoca e blocca il canvas
   */
  blur() {
    const el = document.getElementById('canvas');
    el.style.filter = 'blur(3px)';
    el.style['pointer-events'] = 'none';
  }

  /**
   * Rimuove la sfocatura e riattiva il canvas
   */
  unblur() {
    const el = document.getElementById('canvas');
    el.style.filter = 'none';
    el.style['pointer-events'] = 'all';
  }

  /**
   * Controlla se ad x e y corrisponde un entity id
   * true se l'entity esiste ed é stelezionata false altrimenti
   */
  select(entityId: string, x: number, y: number) {
    const entity = this.world.getEntity(entityId);
    return this.world.entityExists(entity) && this.world.selectOnScreen(entity, x, y);
  }

  /**
   * Imposta la trasparenza di un entity se esiste
   */
  setAlpha(entityId: string, alpha: number) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      // this.world.changeComponentColor(entity, 0, 0, 0, 0, alpha);
      this.world.changeComponentAlpha(entity, 0, alpha);
    }
  }

  /**
   * Ritorna true se lo 'sguardo' punta verso l' entity indicata con tolleranza definita
   */
  isHover(entityId, tolleranza = 30) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      const angle = this.world.getEntiyCameraAngleDeg(entity);
      return angle < tolleranza;
    }
  }

  /**
   * Applica l' effetto hover all'entity (da chiamare ad ogni ciclo di update o meglio al move della camera)
   */
  applyHover(entityId) {
    this.setAlpha(entityId, this.isHover(entityId) ? 0.9 : 0);
  }

  /**
   * Rimuove l'entity dalla coda di rendering
   */
  remove(entityId) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      this.world.removeComponentRenderer(entity);
    }
  }

  /**
   * Aggiunge l'entity alla coda di rendering
   */
  add(entityId) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      this.world.attachComponentRenderer(entity);
    }
  }

  moveEntity(entityId, x, y, z) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      this.world.setSphericalPosition(entity, x, y, z);
      // this.world.followView(entity);
    }
  }

  translateEntity(entityId, x, y, z) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      this.world.translate(entity, x, y, z);
      // this.world.followView(entity);
    }
  }

  resizeEntity(entityId, w, h, z = 10) {
    const entity = this.world.getEntity(entityId);
    if (this.world.entityExists(entity)) {
      this.world.setScale(entity, w, h, z);
    }
  }

}
